var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useState } from 'react';
import SignaturePad from '../../common/SignaturePad';
import { Document, Page, pdfjs } from 'react-pdf';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';
pdfjs.GlobalWorkerOptions.workerSrc = "https://unpkg.com/pdfjs-dist@".concat(pdfjs.version, "/build/pdf.worker.min.mjs");
import { useMutation } from '@tanstack/react-query';
import api from '../../../api';
var DocumentSign = function (_a) {
    var pdfUrl = _a.pdfUrl, extCustomerID = _a.extCustomerID, quoteId = _a.quoteId, formKey = _a.formKey, handleClose = _a.handleClose, handleForm = _a.handleForm;
    var _b = useState(null), err = _b[0], setErr = _b[1];
    var _c = useState(false), showSignaturePad = _c[0], setShowSignaturePad = _c[1];
    var _d = useState(null), numPages = _d[0], setNumPages = _d[1];
    var uploadSignature = useMutation(api.quote.uploadSignature, {
        onError: function (e) {
            var _a, _b;
            setErr(((_b = (_a = e === null || e === void 0 ? void 0 : e.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.message) || (e === null || e === void 0 ? void 0 : e.message));
        },
        onSuccess: function () {
            setErr(null);
        }
    });
    var handleSignClick = function () {
        setShowSignaturePad(true);
        setErr(null); // Clear any previous errors when starting to sign
    };
    function onDocumentLoadSuccess(_a) {
        var numPages = _a.numPages;
        setNumPages(numPages);
    }
    var handleSignatureComplete = function (signatureData) { return __awaiter(void 0, void 0, void 0, function () {
        var response, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, uploadSignature.mutateAsync({
                            externalID: extCustomerID,
                            signature: signatureData,
                            quoteId: quoteId,
                            formKey: formKey
                        })];
                case 1:
                    response = _a.sent();
                    setShowSignaturePad(false);
                    handleClose();
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    // Error is already handled by the mutation's onError callback
                    console.error('Signature upload failed:', error_1);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    return (React.createElement("div", { className: "h-max w-full flex flex-col items-center" },
        err && (React.createElement("div", { className: "w-4/6 mb-4 p-4 bg-red-100 border border-red-400 text-red-700 rounded-lg" },
            React.createElement("div", { className: "flex justify-between items-center" },
                React.createElement("span", null, err),
                React.createElement("button", { onClick: function () { return setErr(null); }, className: "text-red-500 hover:text-red-700 font-bold text-sm sm:text-base md:text-lg lg:text-xl" }, "\u00D7")))),
        !showSignaturePad && (React.createElement("div", { className: "w-full md:w-4/6 py-3 flex flex-col md:flex-row gap-3 md:gap-4 justify-center items-stretch md:items-center" },
            React.createElement("button", { onClick: handleForm, disabled: uploadSignature.isLoading, className: "w-full md:w-auto px-6 py-3 bg-blue-500 hover:bg-blue-600 disabled:bg-blue-300 disabled:cursor-not-allowed text-white font-medium rounded-lg transition-colors duration-200 text-sm sm:text-base md:text-lg" }, "Edit"),
            React.createElement("button", { onClick: handleSignClick, disabled: uploadSignature.isLoading, className: "w-full md:w-auto px-6 py-3 bg-green-500 hover:bg-green-600 disabled:bg-green-300 disabled:cursor-not-allowed text-white font-medium rounded-lg transition-colors duration-200 text-sm sm:text-base md:text-lg" }, "Sign it"))),
        React.createElement("div", { className: "w-full h-full flex flex-col items-center overflow-x-auto" },
            React.createElement("div", { className: "w-full flex lg:justify-center " },
                React.createElement(Document, { file: pdfUrl, onLoadSuccess: onDocumentLoadSuccess, loading: React.createElement("div", { className: "p-10 text-center" }, "Loading PDF..."), className: "flex flex-col " }, Array.from(new Array(numPages), function (el, index) { return (React.createElement("div", { key: "page_container_".concat(index + 1), className: "my-4 shadow-lg bg-white" },
                    React.createElement(Page, { pageNumber: index + 1, renderTextLayer: true, renderAnnotationLayer: true, width: 1200 }))); })))),
        showSignaturePad && (React.createElement("div", { className: "w-4/6 fixed bottom-12 z-50" },
            React.createElement("div", { className: "bg-white rounded-lg shadow-lg p-4" },
                React.createElement("div", { className: "flex justify-between items-center mb-4" },
                    React.createElement("h3", { className: "text-sm sm:text-base md:text-lg lg:text-xl font-medium text-gray-800" }, "Sign Document"),
                    React.createElement("button", { onClick: function () {
                            setShowSignaturePad(false);
                        }, disabled: uploadSignature.isLoading, className: "text-gray-500 hover:text-gray-700 disabled:text-gray-300 disabled:cursor-not-allowed text-sm sm:text-base md:text-lg lg:text-xl font-bold" }, "\u00D7")),
                uploadSignature.isLoading && (React.createElement("div", { className: "mb-4 p-3 bg-blue-100 border border-blue-400 text-blue-700 rounded-lg flex items-center" },
                    React.createElement("div", { className: "animate-spin rounded-full h-4 w-4 border-b-2 border-blue-700 mr-3" }),
                    "Uploading signature...")),
                React.createElement(SignaturePad, { onComplete: handleSignatureComplete, disabled: uploadSignature.isLoading }))))));
};
export default DocumentSign;
